import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['data', 'label'],
  data: () => ({
    options: {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      elements: {
        point: {
          radius: 0
        }
      }
    }
  }),
  mounted() {
    this.renderLineChart()
  },
  computed: {
    chartData: function() {
      return this.data
    },
    chartLabel: function() {
      return this.label
    }
  },
  methods: {
    renderLineChart: function() {
      this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

      this.gradient.addColorStop(0, 'rgba(44, 54,89, 0.5)')
      this.gradient.addColorStop(0.5, 'rgba(44, 54, 89, 0.25)')
      this.gradient.addColorStop(1, 'rgba(44, 54, 89, 0)')
      this.renderChart(
        {
          labels: this.chartLabel,
          datasets: [
            {
              backgroundColor: this.gradient,
              data: this.chartData
            }
          ]
        },
        this.options
      )
    }
  },
  watch: {
    data: function() {
      this._chart.destroy()
      this.renderLineChart()
    }
  }
}
